module.exports = __webpack_public_path__ + "static/minihacienda-be7ab4b7e4c13def7bc5b1ac8f312c41.png";